import React, { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';

const POLL_INTERVAL = 3 * 60 * 1000; // 3 minutes

function RefreshButton() {
  return (
    <button
      type="button"
      onClick={() => { window.location.href = `${window.location.pathname}?v=${Date.now()}`; }}
      style={{
        color: 'white',
        background: 'transparent',
        border: '1px solid white',
        borderRadius: '4px',
        padding: '4px 8px',
        cursor: 'pointer',
        marginLeft: '8px',
      }}
    >
      Refresh
    </button>
  );
}

function VersionChecker() {
  const { enqueueSnackbar } = useSnackbar();
  const initialVersion = useRef(null);
  const [hasNotified, setHasNotified] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`);
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        const { version } = data;

        if (initialVersion.current === null) {
          initialVersion.current = version;
          return;
        }

        if (version !== initialVersion.current && !hasNotified) {
          setHasNotified(true);
          enqueueSnackbar('A new version is available. Refresh to continue.', {
            variant: 'default',
            persist: true,
            action: RefreshButton,
            style: {
              backgroundColor: '#5850EC',
              color: 'white',
            },
          });
        }
      } catch {
        // Silently fail - don't disrupt user experience
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [enqueueSnackbar, hasNotified]);

  return null;
}

export default VersionChecker;
